import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import '../css/AddEditPerson.css';
import '../css/EmailCopyControl.css';
import axios from 'axios';
import { resolvePersonImageUrl } from '../../utils/resolvePersonImageUrl';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Select, { components } from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

// Custom Control: whole field clickable (not just arrow)
const OrgControl = (props) => (
  <components.Control
    {...props}
    innerProps={{
      ...props.innerProps,
      onMouseDown: (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { onControlClick } = props.selectProps;
        if (onControlClick) onControlClick();
      },
    }}
  />
);

// Custom DropdownIndicator: arrow click also toggles menu open/close
const OrgDropdownIndicator = (props) => (
  <components.DropdownIndicator
    {...props}
    innerProps={{
      ...props.innerProps,
      onMouseDown: (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { onControlClick } = props.selectProps;
        if (onControlClick) onControlClick();
      },
    }}
  />
);

// Custom MenuList: search bar inside dropdown, white (target design)
const OrgSearchMenuList = (props) => {
  const { selectProps } = props;
  const inputValue = selectProps.inputValue ?? "";
  const onInputChange = selectProps.onInputChange ?? (() => {});
  return (
    <>
      <div className="org-search-in-menu">
        <input
          type="text"
          className="org-search-input"
          placeholder="Type to search"
          value={inputValue}
          onChange={(e) => onInputChange(e.target.value)}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>
      <components.MenuList {...props}>{props.children}</components.MenuList>
    </>
  );
};

const AddEditPersonForm = ({ organisations = [], roles = [], relations = [] }) => {
  const { id } = useParams(); // Get personId from the URL 
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    name: "",
    mname: "",
    lname: "",
    preferred_name: "",
    date_of_birth: null,
    birth_city: "",
    birth_country: "",
    marital_status: "",
    deceased_date: null,
    email: "",
    email2: "",
    password: "",
    country_id: "",
    gender: "",
    job_title: "",
    address1: "",
    address2: "",
    city: "",
    staff_id: "",
    state: "",
    zipcode: "",
    phone1: "",
    phone2: "",
    fax: "",
    website: "",
    facebook: "",
    twitter: "",
    instagram: "",
    other_social_media: "",
    languages: "",
    comments: "",
    web_desc: "",
    image: "",
    status: true,
    xmas1: false,
    xmas2: false,
  });

  const [profileImage, setProfileImage] = useState(); 
  
const [relationships, setRelationships] = useState([ { assistant_id: "", rel_id: "" } ]);
const [assistants, setAssistants] = useState([]); // List of available assistants
const [relationshipTypes, setRelationshipTypes] = useState([]); // List of relationship types
  const [countries, setCountries] = useState([]);
  const [igfStaffs, setIgfStaffs] = useState([]);
  const [orgns, setOrganisations] = useState([]);
  const [rolenames, setRolenames] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [newRoles, setNewRoles] = useState([ { organisation_id: "", role_id: "", start_date: null, end_date: null, main_role: true } ]);
  const [continentCode, setContinentCode] = useState("");
  const [activeTab, setActiveTab] = useState("Profile");
  const [loading, setLoading] = useState(false);
  const [orgSearchInputs, setOrgSearchInputs] = useState({});
  const [orgMenuOpen, setOrgMenuOpen] = useState({});
  const [roleSearchInputs, setRoleSearchInputs] = useState({});
  const [roleMenuOpen, setRoleMenuOpen] = useState({});
  const [assistantSearchInputs, setAssistantSearchInputs] = useState({});
  const [assistantMenuOpen, setAssistantMenuOpen] = useState({});


  // Fetch person and roles data when personId changes
  useEffect(() => {
    //if (!id) return; // Add mode; no need to fetch data
    setLoading(true);
    const fetchData = async () => {
      try { // ✅ ALWAYS fetch IGF staffs
    const adminResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/admins` );
    setIgfStaffs(adminResponse.data);

    // ✅ Fetch person only in edit mode
        if (id)
        {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/persons/${id}`);             
       setFormData({ 
        ...data.person, date_of_birth: data.person.date_of_birth ? new Date(data.person.date_of_birth) : null, 
        deceased_date: data.person.deceased_date ? new Date(data.person.deceased_date) : null
       });
        setProfileImage(
          resolvePersonImageUrl(data.person.image, process.env.REACT_APP_API_URL || "") ||
            "/images/avatar.png"
        );
        if (data.roles && data.roles.length > 0) {
        setNewRoles(data.roles.map(role => ({  _id: role._id, organisation_id: role.organisation_id?._id || role.organisation_id, role_id: role.role_id?._id || role.role_id, 
          start_date: role.start_date ? new Date(role.start_date) : null , end_date: role.end_date ? new Date(role.end_date) : null, main_role: role.main_role || false, })));
        } else { setNewRoles([ { organisation_id: "", role_id: "", start_date: null, end_date: null, main_role: true }]);}
        if (data.relationships && data.relationships.length > 0) 
          { setRelationships(
  data.relationships.map((rel) => ({
    _id: rel._id,
    assistant_id: rel.assistant_id?._id || rel.assistant_id || "",
    rel_id: rel.rel_id?._id || rel.rel_id || "",
  }))
);}
         else { setRelationships([{ assistant_id: "", rel_id: "" }]); }

        console.log(data.relationships);
        }
        const orgResponse = await axios.get(`${process.env.REACT_APP_API_URL}/organisations`);  
        const roleResponse = await axios.get(`${process.env.REACT_APP_API_URL}/roles`); 
        const orgMap = orgResponse.data.map(({ _id, name }) => ({ _id, name }));
        const roleMap = roleResponse.data.map(({_id, role_name}) => ({_id, role_name}));
        const assistantResponse = await axios.get(`${process.env.REACT_APP_API_URL}/persons`);
        const filteredAssistants = assistantResponse.data.filter(
          (assistant) => assistant._id !== id
        );
        setAssistants(filteredAssistants);
        // Fetch relationship types
        const relTypeResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/relationship-types`
        );       
        setRelationshipTypes(relTypeResponse.data);
        setOrganisations(orgMap);
        setRolenames(roleMap)
      } catch (error) {
        console.error("Error fetching person data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // Fetch countries for dropdown
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/countries`);
        setCountries(response.data);

        if (formData.country_id) {
          const selectedCountry = response.data.find(
            (country) => country._id === formData.country_id
          );
          if (selectedCountry) {
            setContinentCode(selectedCountry.continent);
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, [formData.country_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "country_id") {
      const selectedCountry = countries.find((country) => country._id === value);
      setContinentCode(selectedCountry ? selectedCountry.continent : "");
    }
  };

  const handleRoleInputChange = (e, index, field) => {
  const value = e?.target?.value ?? e;
  setNewRoles(prev =>
    prev.map((role, i) =>
      i === index ? { ...role, [field]: value } : role
    )
  );
};

const handleDateChange = (name, date) => {
  setFormData((prev) => ({
    ...prev,
    [name]: date,
  }));
};

  const [selectedFile, setSelectedFile] = useState(null);
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = () => setProfileImage(reader.result);
    reader.readAsDataURL(file);
  };

  const validateRequiredFields = () => {
    const checks = [
      {
        isEmpty: !String(formData.name || "").trim(),
        message: "Please fill First Name.",
        tab: "Profile",
      },
      {
        isEmpty: !String(formData.lname || "").trim(),
        message: "Please fill Last Name.",
        tab: "Profile",
      },
      {
        isEmpty: !String(formData.email || "").trim(),
        message: "Please fill Email.",
        tab: "Address",
      },
    ];

    const failed = checks.find((check) => check.isEmpty);

  if (failed) {
    alert(failed.message); // popup alert
    setActiveTab(failed.tab); // optional: switch to relevant tab
    return false;
  }

  return true;
};

  const buildSubmitPayload = ({
    roles = newRoles,
    relationships: relationshipRows = relationships,
    ...extraFields
  } = {}) => {
    const filteredRoles = roles.filter(
      (role) => role.organisation_id && role.role_id
    );
    const filteredRelationships = relationshipRows.filter(
      (rel) => rel.assistant_id && rel.rel_id
    );

    return {
      ...formData,
      ...extraFields,
      staff_id: formData.staff_id || null,
      country_id: formData.country_id || null,
      birth_country: formData.birth_country || null,
      roles: filteredRoles,
      relationships: filteredRelationships,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationError("");

    const isValid = validateRequiredFields();
    if (!isValid) {
    return;
    }  

    try {
      const updatedData = buildSubmitPayload();

      if (selectedFile) {
        const formDataToSend = new FormData();
        Object.keys(updatedData).forEach((key) => {
          const value = updatedData[key];
          if (value === null || value === undefined || value === "" || value === "null") {
            return;
          }
          if (key === "roles" || key === "relationships") {
            formDataToSend.append(key, JSON.stringify(updatedData[key]));
          } else {
            formDataToSend.append(key, updatedData[key]);
          }
        });
        formDataToSend.append("image", selectedFile);
        if (id) {
          await axios.put(
            `${process.env.REACT_APP_API_URL}/persons/${id}`,
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
        } else {
          await axios.post(
            `${process.env.REACT_APP_API_URL}/persons`,
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
        }
      } else if (id) {
        await axios.put(`${process.env.REACT_APP_API_URL}/persons/${id}`, updatedData);
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/persons`, updatedData);
      }

      alert(id ? "Individual updated successfully!" : "Individual added successfully!");
    } catch (error) {
      console.error("Error saving person:", error);
      const serverMessage =
        error.response?.data?.message ||
        "Failed to save person. Please check required fields and try again.";
      setValidationError(serverMessage);
    }
  };

  const handleCopy = (text) => {
  if (!text) return;

  navigator.clipboard.writeText(text);
  setShowToast(true);

  setTimeout(() => {
    setShowToast(false);
  }, 2500);
};

  const handleEditorChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      web_desc: content, // Bind editor content to web_desc
    }));
  };

  const handleDeleteImage = async () => {
  try {
    // await axios.delete(
    //   `${process.env.REACT_APP_API_URL}/persons/${id}/image`
    // );
    await axios.put(
      `${process.env.REACT_APP_API_URL}/persons/${id}`,
      buildSubmitPayload({ image: "" })
    );

    setFormData((prev) => ({ ...prev, image: "" }));
    setProfileImage("/images/avatar.png");
    setSelectedFile(null);

  } catch (error) {
    console.error("Error deleting image:", error);
  }
};

  const renderProfileTab = () => (
    <div>
      <div className="row mt-3 g-3">
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Title</label>
          <select
            className="add-person form-select py-3"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
          >
           <option value="">Title</option>
           <option value="Mr.">Mr.</option>
           <option value="Mrs.">Mrs.</option>
           <option value="Ms.">Ms.</option>
           <option value="Dr.">Dr.</option>
           <option value="Prof.">Prof.</option>
          </select>
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Gender</label>
          <select
            className="add-person form-select py-3"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Job Title</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="job_title"
            value={formData.job_title}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
        <label>Owner / Responsible Person</label>
        <select
          name="staff_id"
          value={formData.staff_id || ""}
          onChange={handleInputChange}
          className="add-person form-control py-3"
        >
          <option value="">Select</option>
          {igfStaffs
            .filter(admin => admin.role_name !== "IGF SuperAdmin")
            .map(admin => (
            <option key={admin._id} value={admin._id}>
             {admin.username}
            </option>
          ))}
        </select>
        </div>
      


      </div>

      <div className="row mt-3 g-3">
        <div className="add-person form-group col-12 col-md-6 col-xl-3 ">
          <label>First Name <span className="required-star">*</span></label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Middle Name</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="mname"
            value={formData.mname}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Last Name <span className="required-star">*</span></label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="lname"
            value={formData.lname}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Preferred Name</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="preferred_name"
            value={formData.preferred_name}
            onChange={handleInputChange}
          />
        </div>
      </div>
     
    </div>
  );

  const renderAddressTab = () => (
    <div>
      <div className="row mt-3 g-3">
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Landline</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="phone1"
            value={formData.phone1}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Mobile Phone</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="phone2"
            value={formData.phone2}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Email 1 <span className="required-star">*</span></label>
          <div className="email-copy-wrapper">
          <input
            type="email"
            className="add-person form-control py-3"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
          />
          <button type="button" className="email-copy-btn" onClick={() => handleCopy(formData.email)}>
            <FontAwesomeIcon icon={faCopy} style={{ color: '#D9A128' }} />
          </button>
          </div>

        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Email 2</label>
          <div className="email-copy-wrapper">
          <input
            type="email"
            className="add-person form-control py-3"
            name="email2"
            value={formData.email2}
            onChange={handleInputChange}
          />
          <button type="button" className="email-copy-btn" onClick={() => handleCopy(formData.email2)}>
            <FontAwesomeIcon icon={faCopy} style={{ color: '#D9A128' }} />
          </button>
          </div>
        </div>
        
      </div>
      <div className="row mt-3 g-3">
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Address Line 1</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="address1"
            value={formData.address1}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Address Line 2</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="address2"
            value={formData.address2}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Fax</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="fax"
            value={formData.fax}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Continent</label>
           <input
            type="text"
            className="add-person form-control py-3"
            value={continentCode}
            readOnly
     />
      </div>
        </div>
        <div className="row mt-3 g-3">
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Zip Code</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="zipcode"
            value={formData.zipcode}
            onChange={handleInputChange}
          />
        </div>   
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>City</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="city"
            value={formData.city}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>State</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="state"
            value={formData.state}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Country</label>
          <select
            className="add-person form-select py-3"
            name="country_id"
            value={formData.country_id}
            onChange={handleInputChange}
          >
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country._id} value={country._id}>
                {country.name}
              </option>
            ))}
          </select>
        </div>        
      </div>
    </div>
  );

  const renderPersonalTab = () => (
    <div>
      <div className="row mt-3 g-3">
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Date of Birth</label>
          <div className="date-picker-wrapper">
            <Flatpickr
              value={formData.date_of_birth}
              onChange={([date]) => handleDateChange("date_of_birth", date || null)}
              options={{ dateFormat: "d-M-Y", allowInput: false, disableMobile: true, static: true }}
              placeholder="Select date"
              className="date-picker-input"
            />
            <FontAwesomeIcon icon={faCalendarDays} className="calendar-icon" />
          </div>
        </div>
        
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
       <label>Deceased Date</label>
       <div className="date-picker-wrapper">
         <Flatpickr
          value={formData.deceased_date}
          onChange={([date]) => handleDateChange("deceased_date", date || null)}
          options={{ dateFormat: "d-M-Y", allowInput: false, disableMobile: true, static: true }}
          placeholder="Select date"
          className="date-picker-input"
         />
         <FontAwesomeIcon icon={faCalendarDays} className="calendar-icon" />
       </div>
     </div>

        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>City of Birth</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="birth_city"
            value={formData.birth_city}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Country of Birth</label>          
           <select
            className="add-person form-select py-3"
            name="birth_country"
            value={formData.birth_country}
            onChange={handleInputChange}
          >
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country._id} value={country._id}>
                {country.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="row mt-3 g-3">
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Marital Status</label>
          <select
            className="add-person form-select py-3"
            name="marital_status"
            value={formData.marital_status}
            onChange={handleInputChange}
          >
           <option value="">Marital Status</option>
           <option value="Single">Single</option>
           <option value="Married">Married</option>
           <option value="Widowed">Widowed</option>
           <option value="Separated">Separated</option>
           <option value="Divorced">Divorced</option>           
          </select>
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
        <label>Website</label>
        <input
          type="text"
          className="add-person form-control py-3"
          name="website"
          value={formData.website}
          onChange={handleInputChange}
        />
      </div>
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Facebook</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="facebook"
            value={formData.facebook}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Twitter</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="twitter"
            value={formData.twitter}
            onChange={handleInputChange}
          />
        </div>
        
      </div>
      <div className="row mt-3 g-3">
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Instagram</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="instagram"
            value={formData.instagram}
            onChange={handleInputChange}
          />
        </div>
        <div className="add-person form-group col-12 col-md-6 col-xl-3">
          <label>Other Social Media</label>
          <input
            type="text"
            className="add-person form-control py-3"
            name="other_social_media"
            value={formData.other_social_media}
            onChange={handleInputChange}
          />
        </div>
      </div>
     
    </div>
  );

  const renderOtherTab = () => (
    <div>     
      <div className="row mt-3 g-3">
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
        <label>Languages</label>
        <textarea          
          className="add-person form-control py-3"
          name="languages"
          rows={10} 
          value={formData.languages}
          onChange={handleInputChange}
        />
      </div> 
      <div className="add-person form-group col-12 col-md-6 col-xl-3">
        <label>Internal Comments</label>
        <textarea
          className="add-person form-control py-3"
          name="comments"
          value={formData.comments}
          rows={10}         
          onChange={handleInputChange}
        />
      </div>
      <div className="add-person form-group col-12 col-md-6">
        <label>Website Description</label>
        <Editor
            apiKey="zk2zzdzsc5ofia3cqt9boi8numoj5fr2y4lj21p6lstv9t9t"
            value={formData.web_desc}
            init={{
              height: 246,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
            }}
            onEditorChange={handleEditorChange}
          />       
      </div>
      <div>
      {/* Corrected Structure for Alignment and Styling */}
<div >
        <h6 style={{ marginBottom: "14px" }}>Xmas Cards</h6> 
    <div className="add-person form-group ">
        {/* The Main Heading Label */}
        
        {/* Checkbox 1: Xmas Card */}
        <div className="add-person form-check col-12 col-md-6">
            <input
                type="checkbox"
                className="add-person form-check-input"
                id="xmas1"
                name="xmas1"
                checked={formData.xmas1}
                onChange={(e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.checked }))}
            />
            <label className="add-person form-check-label" htmlFor="xmas1" style={{textAlign: "left"}}>
                Xmas Card
            </label>
        </div>
        </div>
        {/* Checkbox 2: CEO Xmas Card */}
        <div className="add-person form-check col-12 col-md-6 mt-3" style={{paddingLeft:0}}>
            <input
                type="checkbox"
                className="add-person form-check-input"
                id="xmas2"
                name="xmas2"
                checked={formData.xmas2}
                onChange={(e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.checked }))}
            />
            <label className="add-person form-check-label" htmlFor="xmas2">
                CEO Xmas Card
            </label>
        </div>
        
    </div>
</div>
    </div>
    </div>
  );

  const renderRolesTab = () => (
    <div>
      <div className="roles-section">
          <div className="roles-actions">
          <button type="button" className="btn btn-success px-5 py-3" onClick={() => setNewRoles(prev => [...prev,
            { organisation_id: "", role_id: "", start_date: null, end_date: null, main_role: false, },
            ])}> Add Role
          </button>
        </div>
      <div className="roles-list">
        <div className="role-row role-header">
          <div className="col select-col"></div>
          <div className="col organisation-col">Organisation</div>
          <div className="col role-col">Role</div>
          <div className="col date-col">From</div>
          <div className="col date-col">To</div>
          <div className="col date-col"></div>
        </div>


        {newRoles.map((newRole, index) => (
  <div className="role-row new-role" key={`new-${index}`}>
    <div className="col select-col">
      <input type= "radio" name = "mainRole" className= "role-radio" checked={newRole.main_role}
  onChange={() => {
    setNewRoles(prev => prev.map((role, i) => ({...role , main_role: i === index} )) ); }} />
        <span className={`eye-icon ${!newRole.organisation_id ? "disabled" : ""}`} onClick={() => {
          if (!newRole.organisation_id) return; navigate(`/organisation/${newRole.organisation_id}`) }}>
          👁
        </span>
    </div>

    <div className="col organisation-col"> 
      <Select
        classNamePrefix="react-select"
        className="add-person role-input"
        placeholder="Select organisation"
        isSearchable
        options={orgns.map(org => ({ value: org._id, label: org.name }))}
        value={newRole.organisation_id ? { value: newRole.organisation_id, label: orgns.find(o => o._id === newRole.organisation_id)?.name || newRole.organisation_id } : null}
        onChange={(opt) => handleRoleInputChange(opt?.value ?? "", index, "organisation_id")}
        isClearable
        menuIsOpen={!!orgMenuOpen[index]}
        onMenuOpen={() => setOrgMenuOpen(prev => ({ ...prev, [index]: true }))}
        onMenuClose={() => {
          setOrgMenuOpen(prev => ({ ...prev, [index]: false }));
          setOrgSearchInputs(prev => ({ ...prev, [index]: "" }));
        }}
        onControlClick={() => setOrgMenuOpen(prev => ({ ...prev, [index]: !prev[index] }))}
        inputValue={orgSearchInputs[index] ?? ""}
        onInputChange={(v) => setOrgSearchInputs(prev => ({ ...prev, [index]: v }))}
        components={{ Input: () => null, Control: OrgControl, DropdownIndicator: OrgDropdownIndicator, MenuList: OrgSearchMenuList }}
      />
        </div>

    <div className="col role-col">
      <Select
        classNamePrefix="react-select"
        className="add-person role-input"
        placeholder="Select role"
        isSearchable
        options={rolenames.map(r => ({ value: r._id, label: r.role_name }))}
        value={newRole.role_id ? { value: newRole.role_id, label: rolenames.find(r => r._id === newRole.role_id)?.role_name || newRole.role_id } : null}
        onChange={(opt) => handleRoleInputChange(opt?.value ?? "", index, "role_id")}
        isClearable
        menuIsOpen={!!roleMenuOpen[index]}
        onMenuOpen={() => setRoleMenuOpen(prev => ({ ...prev, [index]: true }))}
        onMenuClose={() => {
          setRoleMenuOpen(prev => ({ ...prev, [index]: false }));
          setRoleSearchInputs(prev => ({ ...prev, [index]: "" }));
        }}
        onControlClick={() => setRoleMenuOpen(prev => ({ ...prev, [index]: !prev[index] }))}
        inputValue={roleSearchInputs[index] ?? ""}
        onInputChange={(v) => setRoleSearchInputs(prev => ({ ...prev, [index]: v }))}
        components={{ Input: () => null, Control: OrgControl, DropdownIndicator: OrgDropdownIndicator, MenuList: OrgSearchMenuList }}
      />
    </div>
    <div className="col date-col">
      <div className="date-picker-wrapper">
        <Flatpickr
          value={newRole.start_date}
          onChange={([date]) => handleRoleInputChange(date || null, index, "start_date")}
          options={{ dateFormat: "d-M-Y", allowInput: false, disableMobile: true, static: true }}
          placeholder="Select date"
          className="date-picker-input"
        />
        <FontAwesomeIcon icon={faCalendarDays} className="calendar-icon" />
      </div>
    </div>

    <div className="col date-col">
      <div className="date-picker-wrapper">
        <Flatpickr
          value={newRole.end_date}
          onChange={([date]) => handleRoleInputChange(date || null, index, "end_date")}
          options={{ dateFormat: "d-M-Y", allowInput: false, disableMobile: true, static: true }}
          placeholder="Select date"
          className="date-picker-input"
        />
        <FontAwesomeIcon icon={faCalendarDays} className="calendar-icon" />
      </div>
    </div>
    
    <div className="col action-col">
      <span className="delete-icon" onClick={async() => { const confirmDelete = window.confirm("Are you sure you want to delete this role?");
        if (!confirmDelete) return;  
        // const roleToDelete = newRoles[index]; console.log("Deleting role:", roleToDelete);
        try {
          const updatedRoles = newRoles.filter((_, i) => i !== index);
          setNewRoles(updatedRoles);
        // if (roleToDelete._id) { await axios.delete(`${process.env.REACT_APP_API_URL}/person-roles/${roleToDelete._id}` );}
        // setNewRoles(prev => prev.filter((_, i) => i !== index)); 
        if (id) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/persons/${id}`,
          buildSubmitPayload({ roles: updatedRoles })
        );
      }

        alert("Role deleted successfully!");
         } catch (error) {
        console.error("Delete failed:", error.response?.data || error.message);
        alert("Failed to delete role");} }}
      >
       <i className="fa fa-trash"></i>
      </span>

    </div>

  </div>
))}

        
</div>
    </div>
    </div>
  );

   const renderRelationshipsTab = () => {
return(
    <div>
      <div className="roles-section">
        <div className="roles-actions">
          <button type="button" className="btn btn-success px-5 py-3"
            onClick={() => setRelationships(prev => [ ...prev, { assistant_id: "", rel_id: "" }
              ])} >
            Add New Relationship
          </button>
        </div>  
      <div className="roles-list">
         {relationships.map((rel, index) => {

            const selectedAssistant = assistants.find(
              a => a._id === rel.assistant_id
            );
          
            return (
              <div className="relationship-row new-role" key={rel._id || index}>

                {/* Assistant */}
                <div className="col organisation-col">
                  <Select
                    classNamePrefix="react-select"
                    className="add-person role-input"
                    placeholder="Select Assistant"
                    isSearchable
                    options={assistants.map(a => ({ value: a._id, label: a.name }))}
                    value={rel.assistant_id ? { value: rel.assistant_id, label: assistants.find(a => a._id === rel.assistant_id)?.name || rel.assistant_id } : null}
                    onChange={(opt) => setRelationships(prev => prev.map((r, i) => i === index ? { ...r, assistant_id: opt?.value ?? "" } : r))}
                    isClearable
                    menuIsOpen={!!assistantMenuOpen[index]}
                    onMenuOpen={() => setAssistantMenuOpen(prev => ({ ...prev, [index]: true }))}
                    onMenuClose={() => {
                      setAssistantMenuOpen(prev => ({ ...prev, [index]: false }));
                      setAssistantSearchInputs(prev => ({ ...prev, [index]: "" }));
                    }}
                    onControlClick={() => setAssistantMenuOpen(prev => ({ ...prev, [index]: !prev[index] }))}
                    inputValue={assistantSearchInputs[index] ?? ""}
                    onInputChange={(v) => setAssistantSearchInputs(prev => ({ ...prev, [index]: v }))}
                    components={{ Input: () => null, Control: OrgControl, DropdownIndicator: OrgDropdownIndicator, MenuList: OrgSearchMenuList }}
                  />
                </div>
        <div className="col role-col">
          <select
            className="add-person form-select role-input"
            name="rel_id"
            value={rel.rel_id}
            onChange={(e) =>{
                      const value = e.target.value;
                      setRelationships(prev =>
                        prev.map((r, i) =>
                          i === index ? { ...r, rel_id: value } : r
                        )
                      );
                    }}
                  >
            <option value="">Select Relationship Type</option>
            {relationshipTypes.map((relType) => (
              <option key={relType._id} value={relType._id}>
                        {relType.rel_name}
                      </option>
                    ))}
                  </select>
                </div>
        <div className="col role-col">
          <input type="text" className="role-input" placeholder="Email" value={selectedAssistant?.email || ""}/>
        </div>
        <div className="col role-col">
          <input type="text" className="role-input"  placeholder="Phone" value={ selectedAssistant?.phone2 || selectedAssistant?.phone1 ||"" }  readOnly/>
        </div>

        <div className="col action-col">
          <span className="delete-icon" onClick={async() => { const confirmDelete = window.confirm("Are you sure you want to delete this relation?");
        if (!confirmDelete) return;  
    try {
      const updatedRelationships = relationships.filter(
        (_, i) => i !== index
      );

      setRelationships(updatedRelationships);

      if (id) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/persons/${id}`,
          buildSubmitPayload({ relationships: updatedRelationships })
        );
      }
      alert("Relationship deleted successfully!");
    } catch (error) { console.error("Delete failed:", error.response?.data || error.message); alert("Failed to delete relationship"); }
  }}
>
       <i className="fa fa-trash"></i>
      </span>
        </div>
      </div>
      );
    })}
    </div>
    </div>
    </div>
  );
};
  
  return loading ? (
    <div>Loading...</div>
  ) :  (
    <div className="add-person-form-page mt-4">
      {showToast && ( <div className="custom-toast">  ✔ Email copied to clipboard! </div> )}
      {validationError && (
        <div className="validation-error-toast" role="alert">
          {validationError}
        </div>
      )}

        {/* <div className="row mb-4">
            <div className="col-md-2 col-sm-6 p-5">
            <img src={profileImage} alt="Profile" className="rounded-circle" width="120" />
        <div>
          <button
            type="button"
            className="btn btn-secondary px-5 py-3 mt-2"
            onClick={() => document.getElementById("profileImageInput").click()}
          >
            Upload Profile Photo
          </button>
          <input
            type="file"
            id="profileImageInput"
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleImageUpload}
          />
        </div>
            </div>         
         <div className="col-sm-9 col-md-10 d-flex align-self-center"> <h1>{formData.name || formData.mname || formData.lname
      ? `${formData.name || ""} ${formData.mname || ""} ${formData.lname || ""}`.trim()
      : "Add/Edit Person"}</h1></div>
        </div> */}
        <div className="row border border-white p-3 rounded g-0">
          <div className="col-12">
            <div className="row align-items-center g-3 mb-4 mx-0 add-person-profile-header">
              <div className="col-auto ps-0">
                <div
                  className="profile-image-wrapper d-flex flex-column align-items-stretch add-person-photo-stack"
                >
                  <div className="position-relative" style={{ width: "150px", height: "150px", flexShrink: 0 }}>
                    <img
                      src={
                        selectedFile
                          ? profileImage
                          : resolvePersonImageUrl(formData.image, process.env.REACT_APP_API_URL || "") ||
                            "/images/avatar.png"
                      }
                      alt={formData.name}
                      style={{ width: "150px", height: "150px", borderRadius: "50%", padding: "3px" }}
                    />
                    {(formData.image || selectedFile) && (
                      <button type="button" className="profile-delete-btn" onClick={handleDeleteImage} aria-label="Remove photo">
                        ✕
                      </button>
                    )}
                  </div>
                  <div className="profile-upload-col mt-2">
                    <button
                      type="button"
                      className="btn btn-secondary w-100 py-3 px-2"
                      onClick={() => document.getElementById("profileImageInput").click()}
                    >
                      Upload Photo
                    </button>
                    <input
                      type="file"
                      id="profileImageInput"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={handleImageUpload}
                    />
                  </div>
                </div>
              </div>
              <div className="col add-person-title-col">
                <h1 className="name-title fw-bold display-6">
                  {formData.name || formData.mname || formData.lname
                    ? `${formData.name || ""} ${formData.mname || ""} ${formData.lname || ""}`.trim()
                    : "Add/Edit Person"}
                </h1>
              </div>
            </div>
            <div className="tabs d-flex flex-wrap gap-2">
              {["Profile", "Address", "Personal", "Other", "Roles", "Relationships"].map((tab) => (
                <button
                  key={tab}
                  type="button"
                  className={`btn px-4 py-3 ${activeTab === tab ? "btn-warning" : "btn-success"}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <form onSubmit={handleSubmit} className="mt-4">
              {activeTab === "Profile" && renderProfileTab()}
              {activeTab === "Address" && renderAddressTab()}
              {activeTab === "Personal" && renderPersonalTab()}
              {activeTab === "Other" && renderOtherTab()}
              {activeTab === "Roles" && renderRolesTab()}
              {activeTab === "Relationships" && renderRelationshipsTab()}

              <div className="mt-4 d-flex flex-wrap gap-2">
                <button type="submit" className="btn btn-success px-5 py-3" style={{ fontWeight: "600", minWidth: "150px" }}>
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-secondary px-5 py-3"
                  style={{ minWidth: "150px" }}
                  onClick={() => navigate("/")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
    </div>
  );
};
// className="btn btn-success mt-4 p-3"
export default AddEditPersonForm; 